import { useState } from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import Typography from '@mui/material/Typography'

import videoFile from '@/../assets/videos/tuya_smart_propojeni.mp4'
import { useGetConnectedTuyaApp } from '@/hooks/use-tuya'
import QRCodeGeneration from './qr-code-generation'
import TuyaDevicesWrapper from './devices'
import TuyaTest from './test-button'
import TuyaResetConnectionButton from './reset-connection-button'

export default function Tuya({
    applianceId,
    successCallback,
}: {
    
    applianceId: number,
    successCallback: (arg1: boolean) => void,
}) {

    const [showGeneration, setShowGeneration] = useState<boolean>(false)

    const { status, data, error } = useGetConnectedTuyaApp()

    if (status === 'pending') {
        return <Box sx={{
            py: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <CircularProgress />
        </Box>
    }

    if (error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{error.message}</Box>
            </Box>
        )
    }

    return (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                pb: 3,
            }}>
                <Box>
                    <Typography variant="body1" component="p" mb={1}>
                        Propojte Vaši zásuvku s aplikací Chytrý Bojler. Nejprve připojte zásuvku
                        do Tuya Smart aplikace.
                    </Typography>
                    <Typography variant="body1" component="p">
                        Pokračujte propojením aplikace pod videonávodem.
                    </Typography>
                </Box>

                <Box sx={{ aspectRatio: 9 / 16 }}>
                    <video width="100%" controls loop autoPlay>
                        <source src={videoFile} type="video/mp4" />
                        Váš prohlížeč nepodporuje přehrávání videa.
                    </video>
                </Box>
            </Box>
            {(showGeneration || !data.connected_tuya_app) ?
                <QRCodeGeneration setShowGeneration={setShowGeneration} />
                :
                <>
                    <TuyaDevicesWrapper applianceId={applianceId} setShowGeneration={setShowGeneration}/>
                    <TuyaTest applianceId={applianceId} successCallback={successCallback} />
                    <TuyaResetConnectionButton />
                </>
            }
        </>
    )
}
